import MemberTag from '@/components/Product/MemberTag';
import { useStore } from '@/providers/app-store-provider';
import { CoatingItem } from '../types';
import { handleCoatingDiscountPercent } from '../utils';

export default function CoatingMemberTag({ coatingItem }: { coatingItem: CoatingItem }) {
  const userInfo = useStore((state) => state.userInfo);
  if (userInfo?.is_member === 1 && handleCoatingDiscountPercent(coatingItem, userInfo) <= 0) {
    return <></>;
  }
  return <MemberTag level={userInfo.member_level} />;
}
